class MainProduct extends HTMLElement {
  connectedCallback() {
    this._mainSplide = new Splide('#main-slider', {
      type: 'slide',
      rewind: false,
      pagination: false,
      arrows: false,
      breakpoints: { 1024: { perPage: 1, gap: 8 }, 767: { gap: 8, padding: { right: '10%' } } }
    });
    const thumbnails = new Splide('#thumbnail-slider', {
      fixedWidth: 81,
      fixedHeight: 81,
      gap: 0,
      rewind: false,
      arrows: false,
      pagination: false,
      cover: true,
      isNavigation: true,
      breakpoints: { 767: { fixedWidth: 72, fixedHeight: 72, gap: 0 } },
    });
    this._mainSplide.sync(thumbnails);
    this._mainSplide.mount();
    thumbnails.mount();

    const initialRadio = this.querySelector('input[name="option-1"]:checked');
    if (initialRadio) {
      const initialIndex = parseInt(initialRadio.dataset.imageIndex || '0', 10);
      if (initialIndex > 0) this._mainSplide.go(initialIndex);
    }

    const scrollIcon = document.querySelector('.icon-scroll-to-top');
    const targetSection = document.querySelector('.product-information');
    const submitButton = this.querySelector('.product-form__submit');

    if (scrollIcon && targetSection && submitButton) {
      window.addEventListener('scroll', () => {
        const submitButtonRect = submitButton.getBoundingClientRect();
        scrollIcon.classList.toggle('is-visible', submitButtonRect.top < 0);
      });
      scrollIcon.addEventListener('click', () => {
        targetSection.scrollIntoView({ behavior: 'smooth' });
      });
    }

    this.sectionId = this.dataset.sectionId;

    this._ctrl = null;
    const apiFetch = (url) => {
      if (this._ctrl) this._ctrl.abort();
      this._ctrl = new AbortController();
      return fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        credentials: 'same-origin',
        signal: this._ctrl.signal,
      }).finally(() => { this._ctrl = null; });
    };

    const getProductForm = () => {
      const pf = this.querySelector('product-form');
      return (pf && pf.querySelector('form')) ||
        this.querySelector('form[action^="/cart/add"]') ||
        document.querySelector('form[action^="/cart/add"]');
    };

    const setSellingPlanHidden = (planId) => {
      const form = getProductForm();
      if (!form) return;
      if (!planId) {
        const exist = form.querySelector('input[name="selling_plan"]');
        if (exist) exist.remove();
        return;
      }
      let input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      input.value = planId;
    };

    // Capture-phase submit listener: runs before product-form.js builds FormData.
    // This is the authoritative source of truth for selling_plan at submit time,
    // regardless of async DOM updates or form replacements.
    this.addEventListener('submit', (e) => {
      const form = e.target.closest('form');
      if (!form) return;
      const sub = this.querySelector('input[name="purchase_option"][value="subscription"]');
      const isSub = sub && sub.checked;
      let sp = form.querySelector('input[name="selling_plan"]');
      if (isSub) {
        const planId = sub.dataset.sellingPlanId;
        if (planId) {
          if (!sp) {
            sp = document.createElement('input');
            sp.type = 'hidden';
            sp.name = 'selling_plan';
            form.appendChild(sp);
          }
          sp.value = planId;
        } else if (sp) {
          sp.remove();
        }
      } else {
        if (sp) sp.remove();
      }
    }, true); // capture phase: fires before product-form.js handler on the form

    this.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-qty-minus],[data-qty-plus]');
      if (!btn) return;
      const input = btn.closest('.product-qty__controls')?.querySelector('.qty-input');
      if (!input) return;
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      let val = parseInt(input.value || '1', 10);
      if (btn.hasAttribute('data-qty-minus')) val = Math.max(min, val - 1);
      else val = Math.min(max, val + 1);
      input.value = isNaN(val) ? 1 : val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.addEventListener('input', (e) => {
      const input = e.target.closest('.qty-input');
      if (!input) return;
      const min = parseInt(input.getAttribute('min') || '1', 10);
      const maxAttr = input.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      let val = parseInt(input.value || '1', 10);
      if (isNaN(val) || val < min) val = min;
      if (val > max) val = max;
      input.value = val;
    });

    this.addEventListener('change', (event) => {
      if (event.target.name !== 'purchase_option' && event.target.name !== 'selling_plan_selector') return;

      if (event.target.name === 'purchase_option') {
        if (event.target.value === 'subscription') this.classList.add('is-sub');
        else this.classList.remove('is-sub');
      }

      const isFreq = event.target.name === 'selling_plan_selector';
      const prevSelectValue = isFreq ? event.target.value : null;
      const y = window.scrollY;

      const url = new URL(window.location.href);
      const checkedVariant = this.querySelector('input[name="option-1"]:checked');
      if (checkedVariant) url.searchParams.set('variant', checkedVariant.value);

      if (isFreq) {
        const subRadio = this.querySelector('input[name="purchase_option"][value="subscription"]');
        if (subRadio) {
          subRadio.checked = true;
          subRadio.dataset.sellingPlanId = event.target.value;
          setSellingPlanHidden(event.target.value);
        }
      }

      const sub = this.querySelector('input[name="purchase_option"][value="subscription"]');
      if (sub && sub.checked) {
        const planId = sub.dataset.sellingPlanId || '';
        setSellingPlanHidden(planId);
        if (planId) url.searchParams.set('selling_plan', planId);
      } else {
        setSellingPlanHidden(null);
        url.searchParams.delete('selling_plan');
      }

      url.searchParams.set('sections', this.sectionId);

      apiFetch(url).then((response) => response.json()).then((data) => {
        const wrap = document.createElement('div');
        wrap.innerHTML = data[this.sectionId] || '';

        const incomingPurchase = wrap.querySelector('.purchase-options');
        const targetPurchase = this.querySelector('.purchase-options');
        if (incomingPurchase && targetPurchase) targetPurchase.replaceWith(incomingPurchase);

        const incomingInstall = wrap.querySelector('.shop-pay-installment');
        const targetInstall = this.querySelector('.shop-pay-installment');
        if (incomingInstall && targetInstall) targetInstall.replaceWith(incomingInstall);

        const clean = new URL(url.toString(), window.location.origin);
        clean.searchParams.delete('sections');
        history.replaceState({}, '', clean.toString());

        const subRadio = this.querySelector('input[name="purchase_option"][value="subscription"]');
        const currentPlanId = subRadio && subRadio.checked ? subRadio.dataset.sellingPlanId || null : null;
        setSellingPlanHidden(currentPlanId);

        if (isFreq) {
          const newSelect = this.querySelector('select[name="selling_plan_selector"]');
          if (newSelect) {
            if (prevSelectValue) newSelect.value = prevSelectValue;
            try { newSelect.focus({ preventScroll: true }); } catch { newSelect.focus(); }
          }
        }

        requestAnimationFrame(() => {
          window.scrollTo(0, y);
          requestAnimationFrame(() => window.scrollTo(0, y));
        });
      });
    });

    // Initial state: run after all listeners are registered so dispatchEvent is handled
    const initial = new URL(location.href);
    const hasVariant = initial.searchParams.has('variant');
    const hasPlan = initial.searchParams.has('selling_plan');

    if (hasPlan) {
      this.classList.add('is-sub');
    } else if (hasVariant) {
      const vId = initial.searchParams.get('variant');
      const vRadio = this.querySelector(`input[name="option-1"][value="${vId}"]`);
      const one = this.querySelector('input[name="purchase_option"][value="onetime"]');
      if (vRadio) vRadio.checked = true;
      if (one) one.checked = true;
      this.classList.remove('is-sub');

      const url = new URL(location.href);
      url.searchParams.set('variant', vId);
      url.searchParams.delete('selling_plan');
      url.searchParams.set('sections', this.sectionId);

      apiFetch(url).then(r => r.json()).then((data) => {
        const wrap = document.createElement('div');
        wrap.innerHTML = data[this.sectionId] || '';

        const incomingPurchase = wrap.querySelector('.purchase-options');
        const targetPurchase = this.querySelector('.purchase-options');
        if (incomingPurchase && targetPurchase) targetPurchase.replaceWith(incomingPurchase);

        const incomingInstall = wrap.querySelector('.shop-pay-installment');
        const targetInstall = this.querySelector('.shop-pay-installment');
        if (incomingInstall && targetInstall) targetInstall.replaceWith(incomingInstall);

        const clean = new URL(url.toString(), window.location.origin);
        clean.searchParams.delete('sections');
        history.replaceState({}, '', clean.toString());
      });
    } else {
      const sub = this.querySelector('input[name="purchase_option"][value="subscription"]');
      const planId = sub?.dataset.sellingPlanId;
      if (sub && planId) {
        sub.checked = true;
        this.classList.add('is-sub');
        setSellingPlanHidden(planId);
        sub.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}
customElements.define('main-product', MainProduct);

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this._ctrl = null;
    this._cache = new Map();

    this.querySelectorAll('input[type="radio"]').forEach((element) => {
      element.addEventListener('change', this.handleChange.bind(this));

      const prefetch = () => { if (!element.checked) this._prefetch(element); };
      element.addEventListener('mouseenter', prefetch);
      element.addEventListener('touchstart', prefetch, { passive: true });

      const label = this.querySelector(`label[for="${element.id}"]`) || element.closest('label');
      if (label) {
        label.addEventListener('mouseenter', prefetch);
        label.addEventListener('touchstart', prefetch, { passive: true });
      }
    });
  }

  _probeUrl(variantId, sectionId, isSubSelected, existingPlanId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('sections', sectionId);
    if (isSubSelected && existingPlanId) url.searchParams.set('selling_plan', existingPlanId);
    else url.searchParams.delete('selling_plan');
    return url;
  }

  _prefetch(element) {
    const main = document.querySelector('main-product');
    const sectionId = main.dataset.sectionId;
    const isSubSelected = !!main.querySelector('input[name="purchase_option"][value="subscription"]')?.checked;
    const existingPlanId = new URL(window.location.href).searchParams.get('selling_plan') || '';
    const variantId = element.value;
    const cacheKey = `${variantId}:${isSubSelected ? 1 : 0}:${existingPlanId}`;
    if (this._cache.has(cacheKey)) return;
    const url = this._probeUrl(variantId, sectionId, isSubSelected, existingPlanId);
    this._cache.set(
      cacheKey,
      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then((r) => r.json())
    );
  }

  handleChange(event) {
    const main = document.querySelector('main-product');
    const sectionId = main.dataset.sectionId;

    const imageIndex = parseInt(event.currentTarget.dataset.imageIndex || '0', 10);
    if (main._mainSplide) main._mainSplide.go(imageIndex);

    const isSubSelected = !!main.querySelector('input[name="purchase_option"][value="subscription"]')?.checked;
    const existingPlanId = new URL(window.location.href).searchParams.get('selling_plan') || '';
    const variantId = event.currentTarget.value;

    if (this._ctrl) this._ctrl.abort();
    this._ctrl = new AbortController();
    const { signal } = this._ctrl;

    const cacheKey = `${variantId}:${isSubSelected ? 1 : 0}:${existingPlanId}`;
    const cached = this._cache.get(cacheKey);
    this._cache.delete(cacheKey);

    const urlProbe = this._probeUrl(variantId, sectionId, isSubSelected, existingPlanId);
    const probePromise = cached
      ? cached.catch(() => fetch(urlProbe.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal }).then((r) => r.json()))
      : fetch(urlProbe.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal }).then((r) => r.json());

    probePromise.then((data) => {
      if (signal.aborted) return;

      const wrap = document.createElement('div');
      wrap.innerHTML = data[sectionId] || '';
      const select = wrap.querySelector('select[name="selling_plan_selector"]');

      let finalPlanId = null;
      if (isSubSelected && select) {
        const opts = Array.from(select.options).map((o) => o.value);
        if (existingPlanId && opts.includes(existingPlanId)) finalPlanId = existingPlanId;
        else finalPlanId = select.value || opts[0] || null;
      }

      const urlFinal = new URL(window.location.href);
      urlFinal.searchParams.set('variant', variantId);
      urlFinal.searchParams.set('sections', sectionId);
      if (isSubSelected && finalPlanId) urlFinal.searchParams.set('selling_plan', finalPlanId);
      else urlFinal.searchParams.delete('selling_plan');

      const applyDom = (html, urlToSet) => {
        const frag = document.createElement('div');
        frag.innerHTML = html;
        const incoming = frag.querySelector('.product-information');
        document.querySelector('.product-information').replaceChildren(...incoming.childNodes);

        const clean = new URL(urlToSet.toString(), window.location.origin);
        clean.searchParams.delete('sections');
        history.replaceState({}, '', clean.toString());

        if (isSubSelected && finalPlanId) {
          main.classList.add('is-sub');
          const form =
            main.querySelector(`form[action="${window.routes.cart_add_url}"]`) ||
            main.querySelector('form.product-form') ||
            document.querySelector(`form[action="${window.routes.cart_add_url}"]`);
          if (form) {
            let sp = form.querySelector('input[name="selling_plan"]');
            if (!sp) {
              sp = document.createElement('input');
              sp.type = 'hidden';
              sp.name = 'selling_plan';
              form.appendChild(sp);
            }
            sp.value = finalPlanId;
          }
          const subRadio = main.querySelector('input[name="purchase_option"][value="subscription"]');
          if (subRadio) {
            subRadio.checked = true;
            subRadio.dataset.sellingPlanId = finalPlanId;
          }
        } else {
          main.classList.remove('is-sub');
          const oneRadio = main.querySelector('input[name="purchase_option"][value="onetime"]');
          if (oneRadio) oneRadio.checked = true;
          const form =
            main.querySelector(`form[action="${window.routes.cart_add_url}"]`) ||
            main.querySelector('form.product-form') ||
            document.querySelector(`form[action="${window.routes.cart_add_url}"]`);
          if (form) {
            const sp = form.querySelector('input[name="selling_plan"]');
            if (sp) sp.remove();
          }
        }
      };

      if ((isSubSelected && finalPlanId === existingPlanId) || (!isSubSelected && !existingPlanId)) {
        applyDom(data[sectionId] || '', urlFinal);
      } else {
        fetch(urlFinal.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal })
          .then((response2) => response2.json())
          .then((data2) => { if (!signal.aborted) applyDom(data2[sectionId] || '', urlFinal); })
          .catch(() => {});
      }
    }).catch(() => {});
  }
}

customElements.define('product-options', VariantSelector);